import type {IListApiResponse as IApiResponse } from "../@types/ApiResponse"
import type SelectListDto from "../@types/SelectList"
import { EnumScreenOrientation } from "../@types/template"
import { emptySplitApi } from "./emptySliceApi"
import endpoints from "./endpoints"

export const selectListService = emptySplitApi.injectEndpoints({
    endpoints:(builder)=>({

        GetDistrict: builder.query<IApiResponse<SelectListDto>, {stateId?:Number}>({
            query: ({stateId}) => {
                return {
                    url: endpoints.districts + `${stateId ? `?stateId=${stateId}` : ''}`
                }
            },
        }),
        GetState: builder.query<IApiResponse<SelectListDto>, any>({
            query: () => {
                return {
                    url: endpoints.states
                }
            },
        }),
        GetLocalbodies: builder.query<IApiResponse<SelectListDto>,  {districtId?:Number}>({
            query: ({districtId}) => {
                return {
                    url: endpoints.localbodies+ `${districtId ? `?districtId=${districtId}` : ''}`
                }
            },
        }),
        GetDesignations: builder.query<IApiResponse<SelectListDto>, any>({
            query: () => {
                return {
                    url: endpoints.designations.dropdown
                }
            },
        }),
        GetScreeningRelation: builder.query<IApiResponse<SelectListDto>, any>({
            query: () => {
                return {
                    url: endpoints.screeningRelationsDropDown
                }
            },
        }),
        GetFramesDropdown: builder.query<IApiResponse<SelectListDto>, {orientation:EnumScreenOrientation}>({
            query: ({orientation}) => {
                return {
                    url: endpoints.framesDropdown + `${orientation ? `?screenOrientation=${orientation}` : ''}`
                }
            },
        }),
        GetScreenTypeLists: builder.query<IApiResponse<SelectListDto>,void>({
            query: () => {
                return {
                    url: endpoints.screenTypes
                }
            },
        }),
        GetInstitutionLists: builder.query<IApiResponse<SelectListDto>,void>({
            query: () => {
                return {
                    url: endpoints.institution.dropdown
                }
            },
        }),
        GetScreenLists: builder.query<IApiResponse<SelectListDto>,{institutionId?: number} | void>({
            query: (params) => {
                const institutionId = params && typeof params === 'object' ? params.institutionId : undefined;
                return {
                    url: endpoints.screen.dropdown + `${institutionId ? `?institutionId=${institutionId}` : ''}`
                }
            },
        }),
        GetComponentContentLists: builder.query<IApiResponse<SelectListDto>, {screenId?: number}|void>({
            query: (params) => {
                return {
                    url: endpoints.componentContents.dropdown + `${params && params.screenId ? `?screenId=${params.screenId}` : ''}`
                }
            }
        }),
        GetInstitutionCategoryLists: builder.query<IApiResponse<SelectListDto>,void>({
            query: () => {
                return {
                    url: endpoints.institution.category
                }
            },
        }),
    })
})

export const { 
     useGetDistrictQuery,
     useGetDesignationsQuery,
     useGetLocalbodiesQuery,
     useGetScreeningRelationQuery,
     useGetStateQuery, 
     useGetFramesDropdownQuery,
     useGetScreenTypeListsQuery,
     useGetInstitutionListsQuery,
     useGetScreenListsQuery,
     useGetComponentContentListsQuery,
     useGetInstitutionCategoryListsQuery
    } = selectListService;